/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EntryTicketFlowEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ENTRY_TICKET_FLOW_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class EntryTicketFlowEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EntryTicketFlowEnabledSettingParser.decode(input).map(res => new EntryTicketFlowEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return EntryTicketFlowEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EntryTicketFlowEnabledSettingParser.encode(data);
    }
    static schema() {
        return EntryTicketFlowEnabledSettingParser.schema();
    }
}
